module.exports = __webpack_public_path__ + "static/img/content1.5d828854.png";